import { Tab, Tabs } from '@mui/material';
import { AppConfig } from 'AppConfig';
import { fetchData } from 'features/user/userActions';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, Outlet, useLocation } from 'react-router-dom';
import routePaths from 'routes/routePaths';
import { tabNoUnderlineSx, tabsNoUnderlineSx } from 'common/tabSx';
import { store } from 'store/store';


const AdminNavigator = () => {
  const location = useLocation();
  const USER_ACCESS_URL = routePaths.adminPage;
  const ROLE_MANAGEMENT_URL = `${USER_ACCESS_URL}/${AppConfig.ADMIN_SUB_URL.ROLE_MANAGEMENT}`;
  const USER_GROUP_URL = `${USER_ACCESS_URL}/${AppConfig.ADMIN_SUB_URL.USER_GROUP}`;
  const { defaultUserState, currentTenantCd } = useSelector(
    (state) => state.user
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (defaultUserState) {
        store.dispatch(fetchData(currentTenantCd, AppConfig.APP_CODE_FO, { explicitTenant: false }));
      }
    }, 100);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <Tabs
        value={location.pathname}
        indicatorColor="primary"
        textColor="primary"
        sx={tabsNoUnderlineSx}>
        <Tab
          label="User Access"
          value={USER_ACCESS_URL}
          component={Link}
          to={USER_ACCESS_URL}
          sx={tabNoUnderlineSx}
        />
        <Tab
          label="Role Management"
          value={ROLE_MANAGEMENT_URL}
          component={Link}
          to={ROLE_MANAGEMENT_URL}
          sx={tabNoUnderlineSx}
        />
        <Tab
          label="User Group"
          value={USER_GROUP_URL}
          component={Link}
          to={USER_GROUP_URL}
          sx={tabNoUnderlineSx}
        />
      </Tabs>
      <Outlet />
    </>
  );
};

export default AdminNavigator;
